module.exports = __webpack_public_path__ + "static/media/ic_check.e991ac62.svg";